module.exports = __webpack_public_path__ + "static/menu-Language-a5042c085531d6a0bc3d0ddaa5865e86.png";